/* template */
<template minapp="mpx" xlang="wxml"><div :class="(paddingClass)" class="swiper-container" v-if="(listData && listData.length > 0)"><mpx-swiper display-multiple-items="1" @change="onChange" :indicator-dots="(false)" indicator-color="#FFFFFF" :current="(initIndex)" :autoplay="(false)" :circular="(false)" :class="(swpierPadding)" next-margin="10px" class="swiper"><div v-for="(item, index) in (listData)" :key="item.index"><mpx-swiper-item class="swiper-item"><div :class="(initIndex === index ? 'train-info-content selected' : 'train-info-content unselected')"><refund-info-card :class="(initIndex === index ? '' : 'unselected-item')" :refundInfo="(item)" :showReason="(showReason)"/></div></mpx-swiper-item></div></mpx-swiper></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m2722b72c"}'>
  @import '~@/mixins/stylus/color.styl'

  .swiper-container
    overflow visible
    background-color $train-color-theme-blue
  .swiper
    width 100%
    // height 113px
    // background-color #FFFFFF
    overflow visible
  .swiper-inline-didi-padding
    margin-top -18px
    padding 0px 0px 0px 0px
    margin-bottom -12px
  .swiper-inline-didi-padding-reason
    margin-top -10px
    padding 0px 0px 0px 0px
    margin-bottom -4px
  .swiper-inline-web-padding
    padding 15px 0px
  .swiper-didi-padding
    padding 0px 0px
  .swiper-web-padding
    padding 0px 15px
  .swiper-item
    // height 105px
    display flex
    justify-content center
    align-items center
  .train-info-content
    display flex
    flex-direction column
    width 97%
    background-color #ffffff
    border-radius 8px
    box-sizing border-box
    &.selected
      // min-height 103px
    &.unselected
      // height 73px
      transform scale(1, 0.75)
  .unselected-item
    transform scale(0.75, 1)
  .train-info-item
    padding 13px 15px 16px 15px
  .train-info-item-top
    padding 3px 15px 16px 15px
  .tag
    background-color #e7f1ff
    width 60px
    height 14px
    color $train-color-theme-blue
    border-radius 8px 1px 8px 1px
  .tag-text
    position relative
    margin-top -2px
    font-size 12px
    -webkit-transform scale(0.84)
    -webkit-transform-origin center
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m2722b72c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./train-swiper-card.mpx.js?isComponent&outputPath=components%2Ftrain-swiper-card2722b72c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./train-swiper-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Ftrain-swiper-card2722b72c%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m2722b72c"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/train-swiper-card2722b72c/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'refund-info-card':getComponent(require("./refund-info-card.mpx?isComponent&outputPath=components%2Frefund-info-card3a1bd67e%2Findex")),'mpx-swiper':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-swiper.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-swiper-item':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-swiper-item.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
